// import all images from assets/images directory
import img01 from "../all-images/cars-img/cx5.png";
import img04 from "../all-images/cars-img/note.png";
import img07 from "../all-images/cars-img/axio.png";
import img011 from "../all-images/cars-img/serena.png";
import img023 from "../all-images/cars-img/wish.png";
import img015 from "../all-images/cars-img/alphard.png";
import img022 from "../all-images/cars-img/markx.png";
import img021 from "../all-images/cars-img/prado.png";
import img020 from "../all-images/cars-img/harrierNew.png";

const carLease = [
  {
    id: 1,
    brand: "Economy",
    rating: 102,
    carName: "Economy Class",
    imgUrl: img04,
    model: "Model-2022",
    price: "30,000 - 40,000",
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
    carsInCategory: [
      {
        carName: "Mazda Demio",
      },
      {
        carName: "Nissan Note",
      },
      {
        carName: "Toyota Vitz",
      },
      {
        carName: "Honda Fit",
      },
    ],
  },

  {
    id: 2,
    brand: "Compact",
    rating: 82,
    carName: "Compact Class",
    imgUrl: img07,
    model: "Model 3",
    price: "45,000 - 60,000",
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
    carsInCategory: [
      {
        carName: "Toyota Fielder",
      },
      {
        carName: "Mazda Atenza",
      },
      {
        carName: "Toyota Premio",
      },
      {
        carName: "Mazda Axela",
      },
    ],
  },
  {
    id: 3,
    brand: "Minivan",
    rating: 132,
    carName: "Minivan",
    imgUrl: img011,
    model: "Model-2022",
    price: "60,000 - 65,000",
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
    carsInCategory: [
      {
        carName: "Toyota Noah",
      },
      {
        carName: "Nissan Serena",
      },
      {
        carName: "Toyota Voxy",
      },
    ],
  },

  {
    id: 4,
    brand: "Luxury Minivan",
    rating: 132,
    carName: "Luxury Minivan",
    imgUrl: img015,
    model: "Model-2022",
    price: "70,000 - 75,000",
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
    carsInCategory: [
      {
        carName: "Toyota Alphard",
      },
    ],
  },

  {
    id: 5,
    brand: "Midsize SUV",
    rating: 112,
    carName: "Midsize SUV",
    imgUrl: img01,
    model: "Model 3",
    price: "60,000",
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
    carsInCategory: [
      {
        carName: "Toyota RAV4",
      },
      {
        carName: "Mazda CX5",
      },
      {
        carName: "Nissan Xtrail",
      },
    ],
  },
  {
    id: 6,
    brand: "Large SUV",
    rating: 112,
    carName: "Large SUV",
    imgUrl: img020,
    model: "Model 3",
    price: "65,000 - 70,000",
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
    carsInCategory: [
      {
        carName: "Toyota Harrier",
      },
    ],
  },
  {
    id: 7,
    brand: "Luxury SUV",
    rating: 112,
    carName: "Luxury SUV",
    imgUrl: img021,
    model: "Model 3",
    price: "150,000 - 250,000",
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
    carsInCategory: [
      {
        carName: "Toyota Prado",
      },
    ],
  },
  {
    id: 8,
    brand: "Luxury Sedan",
    rating: 112,
    carName: "Luxury Sedan",
    imgUrl: img022,
    model: "Model 3",
    price: "50,000 - 60,000",
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
    carsInCategory: [
      {
        carName: "Toyota Mark X",
      },
      {
        carName: "Toyota Crown",
      },
      {
        carName: "Nissan Teana",
      },
    ],
  },
  {
    id: 9,
    brand: "Others",
    rating: 112,
    carName: "Others (6 Seaters)",
    imgUrl: img023,
    model: "Model 3",
    price: "50,000 - 60,000",
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
    carsInCategory: [
      {
        carName: "Toyota Wish",
      },
      {
        carName: "Toyota Isis",
      },
    ],
  },
];

export default carLease;
